import { atom } from 'recoil';

export const totalState = atom<number>({
  key: 'totalState',
  default: 0,
});


